export const COMMIT_HASH = process.env.VUE_APP_GIT_COMMIT_HASH